<template>
  <v-flex id="desktop_bar" class="hidden-sm-and-down">
    <v-layout>
      <v-flex grow>
        <router-link to="/map">
          <div class="logo svg-wrap" @click="home()">
            <canvas height="1" width="3"></canvas>
            <svg-logo/>
          </div>
        </router-link>
      </v-flex>
      <v-flex shrink class="link1-line mr-4">
        <router-link :to="{ path: 'modal', query: { video: 1 }}" class="link1 mr-4" style="color:#111;"><v-icon size="26px" color="red" style="position:absolute; left:-18px; top: -3px; ">play_circle_outline</v-icon> 핫딜소개/팁<img :src="`${$utile.getStaticUrl()}/map/icon/icon-hot.svg`" class="pop-point mr-2"/></router-link>
        <router-link to="map" class="link1">방찾기</router-link>
        <span @click="mapData.favoriteView.show = true" class="link1">찜한매물</span>
        <router-link :to="{ path: 'modal', query: { receipt: 1 }}" class="link1">방내놓기</router-link>
        <router-link to="review" class="link1">고객리뷰</router-link>
        <router-link to="customer" class="link1">고객센터</router-link>
        <!--<router-link to="/map" class="link1">리뷰</router-link>-->
      </v-flex>
      <v-flex shrink class="link2-line align-center">
        <div v-if="!auth.isAuth">
          <span class="link2"  @click="move(getBaseUrl() + '/bbs/register')">회원가입</span>
          <span class="link2 separator" @click="auth.modal.login = true">로그인</span>
        </div>
        <v-layout v-if="auth.isAuth">
          <v-flex class="link2" v-if="auth.profile_img !== ''"><img :src="auth.profile_img" class="profile_img"/>{{auth.name}}님</v-flex>
          <v-flex class="link2 separator" v-if="auth.isStaff"><a href="/rep/pro" target="_blank" class="point">관리자</a></v-flex>
          <!--
          <v-flex class="link2 separator " v-if="auth.isStaff" @click="iframeViewOpen('캘린더', `${$utile.getBaseUrl()}/bbs/board?bo_table=pro_calendar&hl=2`)">캘린더</v-flex>
          <v-flex class="link2 separator " v-if="auth.isStaff" @click="iframeViewOpen('방매칭요청', `${$utile.getBaseUrl()}/bbs/board?bo_table=rep_item_request&hl=2`)">방매칭요청</v-flex>
          <v-flex class="link2 separator " v-if="auth.isStaff" @click="iframeViewOpen('방내놔요', `${$utile.getBaseUrl()}/bbs/board?bo_table=rep_item_receipt2&hl=2`)">방내놔요</v-flex>
          -->
          <v-flex class="link2 separator point" v-if="auth.isStaff" @click="iframeViewOpen('', '')">일정/상담관리</v-flex>
          <v-flex class="link2 separator"  @click="move(getBaseUrl() + '/bbs/member_confirm?url=' + getBaseUrl() + '/bbs/register_form')">내정보</v-flex>
          <v-flex class="link2 separator" @click="logout">로그아웃</v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import EventBus from '@/utile/eventBus'
import Utile from '@/utile/utile'
import SvgLogo from '../svg/Logo'
import { mapState, mapActions } from 'vuex'
//
export default {
  components: {
    SvgLogo
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData,
      auth: state => state.auth,
      board: state => state.board
    })
  },
  methods: {
    ...mapActions({
      requestAuthData: 'auth/requestAuthData'
    }),
    iframeViewOpen (title, src) {
      this.mapData.iframeView.title = title
      this.mapData.iframeView.src = src
      this.mapData.iframeView.show = true
    },
    home () {
      EventBus.$emit('resetMapState')
    },
    move (url) {
      window.location.href = url
    },
    getBaseUrl () {
      return Utile.getBaseUrl()
    },
    logout () {
      this.requestAuthData({'type': 'logout'}).then((data) => {
        // 로그아웃
        // console.log('!!!!!!!!!!!!!!1 logout')
      })
    },
    showItemReceipt () {
      /*
      if (this.auth.isAuth) {
        this.board.itemReceipt.show = true
      } else {
        EventBus.$emit('alert', '로그인 후 이용가능합니다.')
        this.auth.modal.login = true
      }
      */
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/DesktopBar.vue